import { translations as admin_en } from "./en/admin";
import { translations as admin_pt } from "./pt/admin";

export const translations = {
  en: admin_en,
  pt: admin_pt,
};
